import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap-icons/font/bootstrap-icons.css";

import { MenuProvider } from 'context/MenuContext';

import { Header } from './components/layout/Header/Headers';
import { Main } from './components/layout/Router_main/Main';
import { Footer } from './components/layout/Footer/Footer';
import { useLocation } from 'wouter';

function App() {
  const [location] = useLocation();
  const hideFooterRoutes = ['/login', '/recovery'];
  const shouldShowFooter = !hideFooterRoutes.some(path => location.startsWith(path));

  return (
    <MenuProvider>
      <div className='container-fluid px-0 app-wrapper'>
        <Header/>
        <Main/>
        {shouldShowFooter && <Footer />}
      </div>
    </MenuProvider>
  );
}

export default App;
